import { render, staticRenderFns } from "./ChapterItem.vue?vue&type=template&id=5aaf3b00&scoped=true&"
import script from "./ChapterItem.vue?vue&type=script&lang=ts&"
export * from "./ChapterItem.vue?vue&type=script&lang=ts&"
import style0 from "./ChapterItem.vue?vue&type=style&index=0&id=5aaf3b00&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaf3b00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/p00353_hh-ballett/client-player/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5aaf3b00')) {
      api.createRecord('5aaf3b00', component.options)
    } else {
      api.reload('5aaf3b00', component.options)
    }
    module.hot.accept("./ChapterItem.vue?vue&type=template&id=5aaf3b00&scoped=true&", function () {
      api.rerender('5aaf3b00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChapterItem.vue"
export default component.exports